import styled from 'styled-components'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import ProjectsList from '@chegg-wt/core/components/Folders/ProjectsList'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const Container = styled.main`
  display: flex;
`

export const MainProjectsList = styled(ProjectsList)`
  flex: 1 1 auto;

  @media screen and (min-width: ${({ theme }) => themeBreakPoints.medium(theme)}) {
    margin-left: ${values.small};
  }
`
